import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/team',
    name: 'Team',
    component: () => import( '../views/Team.vue')
  },
  {
    path: '/clubs',
    name: 'Clubs',
    component: () => import( '../views/Clubs.vue')
  },
  {
    path: '/join',
    name: 'Join Us',
    component: () => import( '../views/Join.vue')
  },
  {
    path: '/competitions',
    name: 'Competitions',
    component: () => import( '../views/Competitions.vue')
  },
  {
    path: '/clubs/psychology',
    name: 'PsychologyClub',
    component: () => import( '../views/Clubs/Psychology.vue')
  },
  {
    path: '/clubs/business',
    name: 'BusinessClub',
    component: () => import( '../views/Clubs/Business.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
